import cls from "./styles.module.css";
import { useObservationByIdLoader } from "@/hooks/network/use-observation-by-id-loader";
import { useSuspenseQuery } from "@tanstack/react-query";
import { QueryKeysConfig } from "@/config/query-keys";
import { withQueryErrorResetBoundary } from "@/components/ErrorBoundary/withQueryErrorResetBoundary";
import { withSuspenseBoundary } from "@/components/withSuspenseBoundary";
import Loading from "./loading";
import FormattedDate from "@/components/FormattedDate";

type TProps = {
  id: string;
};
function Observation({ id }: TProps) {
  const getObservation = useObservationByIdLoader();
  const { data: observation } = useSuspenseQuery({
    queryKey: [QueryKeysConfig.observation, id],
    queryFn: () => getObservation({ data: { id } }),
  });

  return (
    <a
      className={cls.observation}
      target="_blank"
      rel="noopener noreferrer"
      href={observation.url}
    >
      <img
        className={cls.thumb}
        src={observation.thumb}
        alt={observation.name}
      />
      <div>
        <strong>{observation.name}</strong>
        <FormattedDate date={observation?.date} isSSR format="lll" />
      </div>
    </a>
  );
}
export default withQueryErrorResetBoundary(
  withSuspenseBoundary(Observation, <Loading />),
);
